import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { NeuInput } from "./Neu";

// Password field with a show/hide eye toggle, used everywhere passwords are typed.
// `inputClassName` forwards Tailwind classes to the inner NeuInput (size overrides, etc.).
export const PasswordInput = ({ className = "", inputClassName = "", children, ...rest }) => {
  const [shown, setShown] = useState(false);

  return (
    <div className={`relative ${className}`}>
      <NeuInput
        {...rest}
        type={shown ? "text" : "password"}
        dir="ltr"
        className={`pl-4 pr-11 text-left ${inputClassName}`}
      />
      <button
        type="button"
        tabIndex={-1}
        data-testid={`${rest["data-testid"] || "password"}-eye`}
        aria-label={shown ? "hide password" : "show password"}
        onClick={() => setShown((v) => !v)}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground transition-colors duration-200 hover:text-primary"
      >
        {shown ? <EyeOff className="h-6 w-6" /> : <Eye className="h-6 w-6" />}
      </button>
      {children}
    </div>
  );
};
